module.exports = __webpack_public_path__ + "static/media/howItWork4.9c4aa841.png";